import modal, { type ModalComponent } from '../modal';

export default function youtubeModal(): ModalComponent {
    return modal();
}
